import { IKeHoachMonAddRequest } from "../../../model/request/ke-hoach/IKeHoachMonAddRequest";
import { IKeHoachMonToanKhoaSelectRequest } from "../../../model/request/ke-hoach/IKeHoachMonToanKhoaSelectRequest";
import { IKeHoachMonViewModel } from "../../../model/respone/ke-hoach/IKeHoachMonViewModel";
import { IKeHoachToanKhoaAutoWeekParams } from "../../reducer-model/ke-hoach/IKeHoachToanKhoaReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachToanKhoaActionsObj = {
    CHANGE_FILTER: {} as IKeHoachMonToanKhoaSelectRequest,

    LOAD_START: {} as IKeHoachMonToanKhoaSelectRequest,
    LOAD_SUCCESS: {} as IKeHoachMonViewModel[],
    LOAD_ERROR: "",

    UPDATE_START: {} as IKeHoachMonViewModel[],
    UPDATE_SUCCESS: {} as IKeHoachMonViewModel[],
    UPDATE_ERROR: "",

    DELETE_START: {} as number[],
    DELETE_SUCCESS: {} as number[],
    DELETE_ERROR: "",

    SHOW_ADD_MON_MODAL: undefined,
    CLOSE_ADD_MON_MODAL: undefined,
    
    ADDING_MONHOC_START: {} as IKeHoachMonAddRequest,
    ADDING_MONHOC_SUCCESS: undefined,
    ADDING_MONHOC_ERRR: "",

    SHOW_UPDATE_NGAY_HOC_THI_AUTO_MODAL: undefined,
    CLOSE_UPDATE_NGAY_HOC_THI_AUTO_MODAL: undefined,

    CHANGE_AUTO_DATE_WEEK_PARAMS: {} as IKeHoachToanKhoaAutoWeekParams,

    SELECTION_IDS: {} as number[],

    CREATE_LOP_TC_AUTO_START: 0,
    CREATE_LOP_TC_AUTO_SUCCESS: undefined,
    CREATE_LOP_TC_AUTO_ERROR: "",
}

export const eKeHoachToanKhoaActionIds = generateActionTypeIds(eKeHoachToanKhoaActionsObj, "KE_HOACH_TOAN_KHOA")
export type IKeHoachToanKhoaActionTypes = IGenericActionType<typeof eKeHoachToanKhoaActionsObj, "KE_HOACH_TOAN_KHOA">;